import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import React, { useEffect, useState } from 'react';
import { FbProvider } from './context';

const Auth = ({ children }) => {
  const initialToken = getCookie('accessToken');
  const storeId = getCookie('storeId');

  const initialState = {
    authenticated: !!initialToken,
    accessToken: initialToken || '',
    storeId: storeId,
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    const token = getCookie('accessToken');
    setState((prevState) => ({
      ...prevState,
      authenticated: !!token,
      accessToken: token || '',
    }));
  }, []);

  const initiateLogin = () => {};

  const logout = () => {
    deleteCookie('accessToken');
    deleteCookie('refreshToken');
    setState({ authenticated: false, accessToken: '', storeId: '' });
    window.location.reload();
  };

  const handleAuthentication = (data) => {
    setSession(data);
  };

  const setSession = (data) => {
    setState((prevState) => ({
      ...prevState,
      authenticated: true,
      accessToken: data.getIdToken().getJwtToken()
    }));
    const accessToken = data.getIdToken().getJwtToken();
    const refreshToken = data.getRefreshToken().getToken();

    // Set the access token in a cookie
    setCookie('accessToken', accessToken, {
      maxAge: 3600, // 1 hour
      path: '/',
      sameSite: 'Strict'
    });

    setCookie('refreshToken', refreshToken, {
      maxAge: 30 * 24 * 60 * 60, // 30 days
      path: '/',
      sameSite: 'Strict'
    });

    setCookie('authenticated', true, {
      maxAge: 1,
      path: '/',
      sameSite: 'Strict'
    });
  };

  const setAuthenticated = (value) => {
    setState((prevState) => ({
      ...prevState,
      authenticated: value
    }));
  };

  const setUserRoles = (data) => {
    const user = {
      ...data
    };
    setState((prevState) => ({
      ...prevState,
      user
    }));
    user && user?.name && setCookie('name', user.name, {
      maxAge: 1,
      path: '/',
      sameSite: 'Strict'
    });
  };

  const setApplication = (id) => {
    setState((prevState) => ({
      ...prevState,
      application: id
    }));
  };

  const setStoreId = (id) => {
    setState((prevState) => ({
      ...prevState,
      storeId: id
    }));
    setCookie('storeId', id, {
      maxAge: 1,
      path: '/',
      sameSite: 'Strict'
    });
  };


  const authProviderValue = {
    ...state,
    initiateLogin: initiateLogin,
    handleAuthentication: handleAuthentication,
    setUserRoles: setUserRoles,
    setApplication: setApplication,
    setStoreId: setStoreId,
    logout: logout,
    setAuthenticated: setAuthenticated
  };

  return <FbProvider value={authProviderValue}>{children}</FbProvider>;
};

export default Auth;